<template>
  <div>
    <div id="navbar" class="d-flex pa-2">
      <section class="mr-3">
        <router-link :to="{name: 'Forms'}">表單列表</router-link>
      </section>
      <section class="mr-3">
        <router-link :to="{name: 'Dashboard'}">預約列表</router-link>
      </section>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Admin',
  data: () => ({
  })
}
</script>
<style lang="scss" scoped>
#navbar {
  background: #333333;
}
</style>
